import React, {useState, useEffect} from 'react';
import * as S from './InfoBlock.styles';

import IconSelector from '@ibibo/icon-selector';
import {sendEvarData} from '@ibibo/analytics';

const InfoBlock = () => {

  const [langSelected, setLangSelect] = useState(false);
  const [videoLink, setVideoLink] = useState('');
  const [overlayView, setOverlayView] = useState(true);

  // useEffect(() => {
  //   if(getCookie('lang')){
  //     videoLangSelect(getCookie('lang'));
  //   }
  // }, []);

  setTimeout( () => {
    setOverlayView(false);
  }, 10000);

  const hoverHandle = () => {
    if(!langSelected && !overlayView){
      setOverlayView(true);
    }
  }


  const videoLangSelect = (lang) => {
    sendEvarData({
      prop54: `myPartner|signup|personalDetails|videoLanguage|${lang}`
    }, true)

    setLangSelect(true);
    switch (lang){
      case 'hindi':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-hi.mp4');
        setOverlayView(false);
        // setCookie('hindi');
        break;

      case 'kannada':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-ka.mp4');
        setOverlayView(false);
        // setCookie('gujurati');
        break;

      case 'telugu':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-te.mp4');
        setOverlayView(false);
        // setCookie('marathi');
        break;

      case 'tamil':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-ta.mp4');
        setOverlayView(false);
        break;

      case 'malayalam':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-ma.mp4');
        setOverlayView(false);
        break;

      case 'gujarati':
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promo-gu.mp4');
        setOverlayView(false);
        break;

      default :
        setVideoLink('https://mypartnerimgak.mmtcdn.com/media/promotion-with-flight.mp4');
        setOverlayView(false);
        break;
    }
  }

  return (
    <S.InfoBlockWrapper>
      <S.InfoBlockInner>
        <S.InfoHeadWrapper>
          {/* <S.InfoHeadText>Check out this video to know more</S.InfoHeadText> */}
          <S.VideoWrapper>
            <S.VideoInnerWrap id='videoBlock' onMouseOver={hoverHandle}>
            {overlayView &&
              <S.VideoSelectWrap>
                <S.SelectHeadText>Choose audio language:</S.SelectHeadText>
                <S.SelectOptionList>
                  <li onClick={() => videoLangSelect('english')}>English</li>
                  <li onClick={() => videoLangSelect('hindi')}>हिंदी</li>
                  <li onClick={() => videoLangSelect('kannada')}>ಕನ್ನಡ</li>
                  <li onClick={() => videoLangSelect('telugu')}>తెలుగు</li>
                  <li onClick={() => videoLangSelect('tamil')}>தமிழ்</li>
                  <li onClick={() => videoLangSelect('malayalam')}>മലയാളം</li>
                  <li onClick={() => videoLangSelect('gujarati')}>ગુજરાતી</li>
                </S.SelectOptionList>
              </S.VideoSelectWrap> || null}
            {!langSelected &&
              <video width="100%" height="100%" controls={true} autoPlay={false} muted playsInline style={{maxHeight:'320px', outline: 'none', borderRadius: '16px'}}>
                <source src="https://mypartnerimgak.mmtcdn.com/media/promotion-with-flight.mp4" type="video/mp4"/>
              </video>
             ||
              <video width="100%" height="100%" controls={true} autoPlay={false} playsInline style={{maxHeight:'320px', outline: 'none', borderRadius: '16px'}} src={videoLink}>
                {/* <source src={videoBlock} type="video/mp4"/> */}
              </video>
            }
            </S.VideoInnerWrap>
          </S.VideoWrapper>
          {/* <S.BannerImgWrap>
            <S.BannerImg  >
            <S.BannerImgAltText>Free Sign Up!</S.BannerImgAltText>
            </S.BannerImg >
          </S.BannerImgWrap> */}
          <S.FlightBannerImgWrap>
            <S.FlightBannerInnerWrap>
              <S.FlightBannerImgInner>
                <IconSelector iconKey='flightfailed' />
              </S.FlightBannerImgInner>
              <S.FlightIntroTextWrap>
                <S.IntroTextHeadFight>Introducing Flights on myPartner</S.IntroTextHeadFight>
                <S.IntoTextSubFlight>Everything Here is Just One Click Away!</S.IntoTextSubFlight>
                {/* <S.IntroTextHeadFight>Get Rs 500 Promotional Discount</S.IntroTextHeadFight>
                <S.IntoTextSubFlight>on completing your sign-up before 31st August 2021</S.IntoTextSubFlight> */}
              </S.FlightIntroTextWrap>
            </S.FlightBannerInnerWrap>
          </S.FlightBannerImgWrap>
        </S.InfoHeadWrapper>
        <S.HomeBannerWrap>
          {/* <S.BannerCountInnerLeft>
            <S.BannerCountHeadText>72,000+</S.BannerCountHeadText>
            <S.BannerCountSubText>Domestic Properties</S.BannerCountSubText>
          </S.BannerCountInnerLeft>
          <S.BannerCountInnerRight>
            <S.BannerCountHeadText>5,00,000+</S.BannerCountHeadText>
            <S.BannerCountSubText>International Properties</S.BannerCountSubText>
          </S.BannerCountInnerRight> */}
          <IconSelector iconKey='homebanner' />
        </S.HomeBannerWrap>
      </S.InfoBlockInner>
    </S.InfoBlockWrapper>
  );
};

export default InfoBlock;
